export const PRE_PAID = "PRE-PAID";
export const CURR_TYPE = "CURR-TYPE";
export const SET_LANG = "SET-LANG";
export const SET_AMOUNT = "SET-AMOUNT";
export const CLEAR_AMOUNT = "CLEAR-AMOUNT";
